import firebase from 'firebase/compat/app';
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider, RecaptchaVerifier } from "firebase/auth";
import { getDatabase } from "firebase/database";


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBtaDQskvoBzmyMQWtUn-qUPs8rrUPXqDE",
  authDomain: "etheware-live.firebaseapp.com",
  databaseURL: "https://etheware-live-default-rtdb.firebaseio.com",
  projectId: "etheware-live",
  storageBucket: "etheware-live.appspot.com",
  messagingSenderId: "948539583365",
  appId: "1:948539583365:web:4c43f7eb8f5445686d72ec",
  measurementId: "G-D5FCKTWW07"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence); // ensures it persists across tabs + subdomains
auth.useDeviceLanguage();
auth.setPersistence(browserLocalPersistence);
auth.tenantId = null; // Only if you're not using multi-tenancy
const database = getDatabase(app);
const googleProvider = new GoogleAuthProvider();



export { auth, database, googleProvider, RecaptchaVerifier };

export default firebase